import { ref, onMounted, onBeforeUnmount } from 'vue';
import breakpoints from '@/assets/js/breakpoints';

export function useBreakpoint() {
    const width = ref(screen.width);

    const isSm = ref(false);
    const isMd = ref(false);
    const isXl = ref(false);
    const isLg = ref( false)
    
    function update() {
        width.value = window.innerWidth;
        isSm.value = width.value < breakpoints.sm;
        isMd.value = width.value >= breakpoints.sm && width.value < breakpoints.md;
        isXl.value = width.value >= breakpoints.md && width.value < breakpoints.xl;
        isLg.value = width.value >= breakpoints.xl;
    }

    onMounted(() => {
        update();
        window.addEventListener('resize', update);
    });

    onBeforeUnmount(() => {
        window.removeEventListener('resize', update);
    });

    return { width, isSm, isMd, isXl, isLg };
}
